import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { BoxesInterface } from '../../widget-photos-teaser-circle.props';

import './widget-photos-teaser-circle-boxes.scss';

interface WidgetPhotosTeaserCircleBoxesInterface {
    boxes: BoxesInterface[];
}

const WidgetPhotosTeaserCircleBoxes: React.FC<WidgetPhotosTeaserCircleBoxesInterface> = ({ boxes }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="boxes">
            <div className="boxes__list">
                { boxes.map((item) => (
                    <a
                        className="boxes__list__item"
                        href={item.url}
                        key={item.img}
                        target={item.target}
                        rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                    >
                        <div className="boxes__list__item__image">
                            <picture>
                                <source srcSet={item.img}/>
                                <img
                                    src={item.img}
                                    alt={item.alt}
                                    width={216}
                                    height={170}
                                />
                            </picture>
                        </div>
                        <div className="boxes__list__item__cta">
                            {item.cta}
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosTeaserCircleBoxes;
